import React, { useContext, useState, useEffect, useRef } from "react";
import { Dropdown, Image, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { stageActions } from '../../actions/';
import MoreVertival from '../../images/icons/more-vertical.svg';
import {
  CircleAddIcon,
  UpArrowIcon,
  DownArrowIcon,
  EditIcon,
  TimeIcon,
  EyeIcon,
  CheckIcon,
  ReminderIcon
} from '../../components'
import { WorkspaceShowContext } from "../../contexts/WorkspaceShowContext";
import { CircleCheckBox } from "../form/CircleCheckBox";
import FlatThreeDot from "../icons/FlatThreeDot";

function EditStageDropdown(props) {
  const {
    stage,
    setShowAddContentGroupField,
    inactiveSearchText,
    button_style,
    className = ''
  } = props;
  const dispatch = useDispatch();
  const {
    workspace_id,
    can_access_stage,
    can_access_content,
    can_access_sort_stage,
    handleSortByDueDateStage,
    handleShowDeleteStagePopup
  } = useContext(WorkspaceShowContext);

  // States
  const [enable_revision, setEnableRevision] = useState(false)
  const [enable_timestamp, setEnableTimeStamp] = useState(false)
  const [visible_to_client, setVisibleToClient] = useState(false)
  const [require_approval_from_client, setRequireApprovalFromClient] = useState(false)

  const handleOnBlur = () => {};
  const handleInlineStageEdit = (event) => {

    let values = {}
    values[event.target.name] = event.target.checked

    switch(event.target.name){
      case 'enable_revision':
        setEnableRevision((prevState) => stage[event.target.name])
        break;
      case 'enable_timestamp':
        setEnableTimeStamp((prevState) => stage[event.target.name])
        break;
      case 'visible_to_client':
        setVisibleToClient((prevState) => stage[event.target.name])
        break;
      case 'require_approval_from_client':
        setRequireApprovalFromClient((prevState) => stage[event.target.name])
        break;
    }

    dispatch(stageActions.inlineEditStage(handleOnBlur, values, workspace_id, stage?.id));
  }

  const handleClickStageSetting = (setting_name) =>{
    let values = {}

    switch(setting_name){
      case 'enable_revision':
        values[setting_name] = !enable_revision
        setEnableRevision((prevState) => !enable_revision)
        break;
      case 'enable_timestamp':
        values[setting_name] = !enable_timestamp
        setEnableTimeStamp((prevState) => !enable_timestamp)
        break;
      case 'visible_to_client':
        values[setting_name] = !visible_to_client
        setVisibleToClient((prevState) => !visible_to_client)
        break;
      case 'require_approval_from_client':
        values[setting_name] = !require_approval_from_client
        setRequireApprovalFromClient((prevState) => !require_approval_from_client)
        break;
    }

    dispatch(stageActions.inlineEditStage(handleOnBlur, values, workspace_id, stage?.id));
  }

  useEffect(() => {
    if(stage){
      setEnableRevision((prevState) => stage.enable_revision)
      setEnableTimeStamp((prevState) => stage.enable_timestamp)
      setVisibleToClient((prevState) => stage.visible_to_client)
      setRequireApprovalFromClient((prevState) => stage.require_approval_from_client)
    }
  }, [stage])

  return (
    <>
      {
        stage &&
        <div className="d-inline-block">
          <Dropdown className={`stage-dropdown ${className}`}>
            <Dropdown.Toggle variant="primary" id="dropdown-basic" className="btn-transparent d-flex justify-content-center align-items-center" title="Options" style={button_style}>
              <FlatThreeDot />
            </Dropdown.Toggle>
            <Dropdown.Menu style={{right: "auto"}} className="stage-dropdown__menu">
              {
                can_access_sort_stage &&
                <>
                  <label>Sort By Due Date</label>
                  <Dropdown.Item
                    onClick={() => handleSortByDueDateStage(stage.id, "asc")}
                    className="stage-dropdown__button stage-dropdown__button__sort d-flex align-items-center"
                  >
                    <UpArrowIcon
                      color={'#727580'}
                      className={"mr-4"}
                      height={'12'}
                      width={'11'}
                    />
                    Ascending
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => handleSortByDueDateStage(stage.id, "desc")}
                    className="stage-dropdown__button stage-dropdown__button__sort d-flex align-items-center mb-12px"
                  >
                    <DownArrowIcon
                      color={'#727580'}
                      className={"mr-4"}
                      height={'12'}
                      width={'11'}
                    />
                    Descending
                  </Dropdown.Item>
                </>
              }
              {
                can_access_stage &&
                <>
                  <label>Settings</label>
                  <div
                    className="stage-dropdown__button stage-dropdown__button__revision dropdown-item"
                    onClick={ () => handleClickStageSetting('enable_revision') }
                  >
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-items-center">
                        <span className="mr-2">
                          <CircleCheckBox 
                            isChecked={ enable_revision }
                            height={18}
                            width={18}
                          />
                        </span>

                        Revision Count
                      </div>
                    </div>
                  </div>
                  <div
                    className="stage-dropdown__button dropdown-item"
                    onClick={ () => handleClickStageSetting('enable_timestamp') }
                  >
                    <div className="d-flex align-items-center">
                      <span className="mr-2">
                        <CircleCheckBox 
                          isChecked={ enable_timestamp }
                          height={18}
                          width={18}
                        />
                      </span>
                      Time Track
                    </div>
                  </div>
                  <div
                    className="stage-dropdown__button dropdown-item"
                    onClick={ () => handleClickStageSetting('visible_to_client') }
                  >
                    <div className="d-flex align-items-center">
                      <span className="mr-2">
                        <CircleCheckBox 
                          isChecked={ visible_to_client }
                          height={18}
                          width={18}
                        />
                      </span>
                      Visible To Guest
                    </div>
                  </div>

                  <div
                    className="stage-dropdown__button dropdown-item stage-dropdown__button__approval mb-12px"
                    onClick={ () => handleClickStageSetting('require_approval_from_client') }
                  >
                    <div className="d-flex align-items-center">
                      <span className="mr-2">
                        <CircleCheckBox 
                          isChecked={ require_approval_from_client }
                          height={18}
                          width={18}
                        />
                      </span>
                      Require Approval
                    </div>
                  </div>
                  <Dropdown.Item
                    onClick={() => handleShowDeleteStagePopup(stage.id)}
                    className="stage-dropdown__button stage-dropdown__button__delete"
                  >
                    Delete Stage
                  </Dropdown.Item>
                </>
              }
            </Dropdown.Menu>
          </Dropdown>
        </div>

      }
    </>
  );
}

export { EditStageDropdown };
